var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnBattery2040(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 23,
    viewBox: "0 0 10 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.5L2 21L8 21L8 18.5L2 18.5Z",
    fill: "#78D79B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15L2 17.5L8 17.5L8 15L2 15Z",
    fill: "#78D79B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39091 2.1561L-8.99473e-07 2.15611L0 22.7336L10 22.7336L10 2.1561L7.60909 2.1561L7.60909 -4.6109e-05L2.39091 -4.58809e-05L2.39091 2.1561ZM9.20909 2.83204L9.20909 21.9294L0.972727 21.9294L0.972726 2.83204L9.20909 2.83204Z",
    fill: "#78D79B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBattery2040);
export default __webpack_public_path__ + "static/media/icn_battery_20_40.53332c33.svg";
export { ForwardRef as ReactComponent };